import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import '../../assets/styles/login.css';
import uumcLogo from '../../assets/images/uumc-logo.jpg';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const res = await fetch(`https://uumcirvine-attendance.duckdns.org/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });

            const data = await res.json();

            if(!res.ok) {
                setError(data.error);
                return;
            }

            login(data.token, data.user);
            navigate('/');

        } catch(err) {
            setError(`Unable to login: ${err}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='page'>
            <div className='leftPanel'>
                <div className='logoWrap'>
                    <img src={uumcLogo} className='logoImg' alt="UUMC logo"/>
                    <span className='brand'>UUMC Attendance</span>
                </div>
                <div>
                    <div className='headline'>Track attendance,<br/>stay connected.</div>
                    <div className='leftSub'>Manage your church's attendance records securely and efficiently.</div>
                </div>
                <div className='leftFooter'>University United Methodist Church</div>
            </div>

            <div className='rightPanel'>
                <div>
                    <h1 className='title'>Welcome back</h1>
                    <p className='subtitle'>Sign in to your account to continue</p>
                </div>

                {error && <div className='error' >{error}</div>}

                <form onSubmit={handleSubmit} className='form'>
                    <div className='field'>
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className='field'>
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className='button'
                        disabled={loading}
                    >
                        {loading ? 'Signing in...' : 'Sign in'}
                    </button>
                </form>
                <div className='footerNote'>Only authorized staff can access this system</div>
            </div>
        </div>
    )
}

export default Login;